import { FiLock, FiX } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

export default function LoginPromptModal({ show, onClose }) {
  const navigate = useNavigate();

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="relative bg-dark-700 border border-dark-400 rounded-2xl shadow-2xl max-w-sm w-[90%] p-8 text-center">
        {/* Close button */}
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-3 right-3 p-1.5 text-gray-500 hover:text-white transition-colors"
          >
            <FiX size={18} />
          </button>
        )}

        {/* Icon */}
        <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-primary/10 flex items-center justify-center">
          <FiLock size={28} className="text-primary" />
        </div>

        {/* Message */}
        <h3 className="text-lg font-bold text-white mb-2">Sign in to watch</h3>
        <p className="text-sm text-gray-400 mb-6">
          You need to sign in to watch this content.
        </p>

        {/* Actions */}
        <div className="flex flex-col gap-3">
          <button
            onClick={() => navigate("/login")}
            className="btn-play-gradient w-full py-3 rounded-xl font-semibold text-sm"
          >
            Sign In
          </button>
          <button
            onClick={() => navigate("/register")}
            className="w-full py-3 rounded-xl font-semibold text-sm border border-white/20 text-gray-300 hover:border-white/40 hover:text-white transition-all"
          >
            Create Account
          </button>
          {onClose && (
            <button
              onClick={onClose}
              className="text-sm text-gray-500 hover:text-gray-300 transition-colors mt-1"
            >
              Maybe later
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
